import { render, staticRenderFns } from "./OnboardWorkspace.vue?vue&type=template&id=40b8a959&scoped=true&"
import script from "./OnboardWorkspace.vue?vue&type=script&lang=js&"
export * from "./OnboardWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b8a959",
  null
  
)

export default component.exports